$(document).ready(function(e) {
  $('#shape-slider').owlCarousel({
    items:10,loop:true,margin:5,dots:false,nav:false,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,
    responsive:{
      300:{items:4, center:true},
      390:{items:5},
      640:{ items:6, margin:5 },
      767:{ items:8 },
      1230:{ items:10 },
    }
  });

  $('#sub-collection-slider').owlCarousel({
    items:10,loop:false,margin:20,dots:false,nav:true,autoplay:false,
    responsive:{
      320:{items:4, margin:5},
      480:{ items:4,},
      767:{ items:5 },
      1230:{ items:10 },
    }
  });
  $('#textual-bnr').owlCarousel({
    items:3,loop:true,margin:10,dots:false,nav:false,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,
    responsive:{
      200: { items: 1 },
      340: { items: 2 ,center:true, margin:5},
      630: { items: 3 },
      980: { items: 3 },
    }
  });
$('.social').owlCarousel({
			autoplay: false,
			dots: false,
			nav: false,
			navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
			rewind: true,
			autoplayTimeout: 5000,
			loop: true,
			items: 8,
			margin: 10,
			responsive: {
				200: { items: 2 },
                340: { items: 2, center:true},
				400: { items: 3 ,},
				630: { items: 4, },
				980: { items: 5, },
				1200: { items: 8 ,}
			}
		});
  
  $('#category-slider').owlCarousel({
    items:3,loop:true,margin:20,dots:false,nav:true,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,responsive:{320:{
    items:1},640:{ items:2 },767:{ items:3 },1230:{ items:3 }}
  });
    $('#natural-slider').owlCarousel({items:4,loop:true,margin:20,dots:false,nav:true,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,responsive:{320:{
    items:2,margin:8},640:{ items:2,margin:8 },767:{ items:3 },991:{ items:4 }}
  });
  $('#natural-lab-slider').owlCarousel({items:4,loop:true,margin:20,dots:false,nav:true,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,responsive:{320:{
    items:2,margin:8},640:{ items:2,margin:8 },767:{ items:3 },991:{ items:4 }}
  });
  $('.natural-best-seller').owlCarousel({items:5,loop:true,margin:20,dots:false,nav:false,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,responsive:{
    200:{items:1,margin:8},320:{items:2,margin:8},640:{ items:3,margin:8 },767:{ items:3 },991:{ items:3 }, 1200:{ items:5 }}
  });
  $('#lab-best-seller').owlCarousel({items:4,loop:true,margin:20,dots:false,nav:false,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,responsive:{320:{
    items:2,margin:5},640:{ items:2,margin:8 },767:{ items:3},991:{ items:4 }}
  });
  $('#ready-best-seller').owlCarousel({items:4,loop:true,margin:20,dots:false,nav:false,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,responsive:{320:{
    items:2,margin:8},640:{ items:2,margin:8 },767:{ items:3 },991:{ items:4 }}
  });
  /////
  $('.natural-best-all-slider').owlCarousel({items:4,loop:true,margin:20,dots:false,nav:false,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,responsive:{320:{items:2,margin:8},640:{ items:2,margin:8 },767:{ items:3 },991:{ items:4 }}
  });

  $('.shop-by-slider').owlCarousel({loop:true,margin:10,dots:false,nav:true,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,mouseDrag: false,
    responsive:{
      320:{items:3},
      640:{ items:5},
      1230:{ items:8 }
      }
  });

   $('.bracelet-slider').owlCarousel({loop:true,margin:10,dots:false,nav:true,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,mouseDrag: false,
    responsive:{
      320:{items:3},
      640:{ items:5},
      1230:{ items:5 }
      }
  });

   $('.related-item-slider').owlCarousel({items:3,loop:true,margin:10,dots:false,nav:true,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,mouseDrag: true,
    responsive:{
      320:{items:1},
      640:{items:3} 
      }
  });
   $('.related-item-slider-mobile').owlCarousel({items:1,loop:true,margin:10,dots:false,nav:true,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,mouseDrag: true,
    responsive:{
      100:{items:1},
      640:{items:1} 
      }
  });
  $('.prdct-gallery').owlCarousel({items:6,loop:true,margin:15,dots:false,nav:true,autoplay:false,autoplayTimeout:5000,autoplayHoverPause:true,mouseDrag: true,
    responsive:{
      300:{items:1},
      345:{items:2},
      640:{items:3},
      767:{items:4},
      991:{items:6}
      }
  });


$('.product__accordion summary').click(function(){
    var sib = $(this).parents('.product__accordion').siblings('.product__accordion').find('details');
    $(sib).removeAttr('open');
    $('html, body').animate({scrollTop: $(".accordian-descptn").offset().top-150}, 1000);
});

  $(".read-more").click(function () {$(".content-show").toggle()});
   $(".more").click(function () {
    // alert($(this).text());
      if($(this).text() == '[Read More..]'){ 
       $(".content-show").slideDown();
        $(this).text('[Read less..]'); }
      else{ 
        $(".content-show").slideUp();
        $(this).text('[Read More..]');
      }  
   });
/////
   $('input[name="properties[Chain Length]"]').on('change', function () {
    var addonValue = $(this).data('addon'); // Get data-addon value
    $('#chain-len-id').val(addonValue);     // Set it as value of hidden input
    console.log('Updated hidden input value:', addonValue);
  });
 //////

  
  
});